"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlActiveSessionAttemptsValidation = void 0;
const ChargingSessionAttemptValidation_1 = require("./ChargingSessionAttemptValidation");
class ChargerControlActiveSessionAttemptsValidation {
    static isValid(entity) {
        // Validate entity.attempts for existence and correct type.
        if (entity.attempts == undefined)
            return false;
        if (!Array.isArray(entity.attempts))
            return false;
        if (!entity.attempts.every((elem) => {
            if (!ChargingSessionAttemptValidation_1.ChargingSessionAttemptValidation.isValid(elem))
                return false;
            return true;
        }))
            return false;
        return true;
    }
}
exports.ChargerControlActiveSessionAttemptsValidation = ChargerControlActiveSessionAttemptsValidation;
